import { BaseFromFilterEvent } from "./BaseFromFilterEvent";

export class FilterNGraphConfig {
    id: string; //allow service and template to easily target a specific configuration
    title: string;
    selectedTagsUid: Array<string>
    isRequesting: boolean; //handle loader display
    hasTruncatedDate: boolean //handle truncated date message display
    filterConfig?: BaseFromFilterEvent; //filters values

    constructor(title: string, selectedTagsUid: Array<string>){
        this.id = Date.now().toString() + '-' + Math.random().toString();
        this.title = title;
        this.selectedTagsUid = selectedTagsUid;
        this.isRequesting = false;
        this.hasTruncatedDate = false;
    }
}